import Icon from 'ui/Element/Icon'

/**
 * ListItemCellIcon element.
 *
 * Displays an icon.
 *
 * @param {Object} props  element's properties
 * @returns {JSX.Element} the new ListItemCellIcon element
 */
export const ListItemCellIcon = (props) => {
  const {
    icon: {
      name,
      color = 'black.main',
      background = 'background.selected',
      rounded = false,
    } = {},
  } = props || {}

  return (
    <Icon
      name={name}
      size={'1.2rem'}

      color={color}
      shape={rounded ? 'circle' : null}
      background={background}
    />
  )
}

export default ListItemCellIcon
